<template>
    <v-card flat>
        <v-btn v-bind="props" v-on="{ click }" class="tool-prev">
            <span>
                <span> 이전 </span>
                <span class="d-none d-lg-inline"> {{ typeText }} </span>
            </span>
            <template v-if="isDone">
                <v-icon> {{ icon }} </v-icon>
            </template>
            <template v-else>
                <v-icon style="color:white!important"> {{ icon }} </v-icon>
            </template>
        </v-btn>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import { EMPLOYMENT_FIELD_TYPES } from "@/assets/variables";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField | null>} */
        value: { type: Object, default: null },
    },
    computed: {
        ...mapState("ui", {
            icon: ({ window }) => (window.innerWidth < 1024 ? "mdi-chevron-left" : "mdi-chevron-up"),
        }),
        disabled() {
            return !this.value;
        },
        isDone() {
            let { type, img, data } = this.value || {};
            switch (type) {
                case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                    return !!img;
                }
                default: {
                    return !!data;
                }
            }
        },
        props() {
            let { disabled, isDone } = this;
            if (isDone) {
                return {
                    block: true,
                    disabled,
                    outlined: true,
                };
            }
            return {
                block: true,
                color: "primary",
                disabled,
            };
        },
        typeText() {
            if (!this.value) return "입력없음";
            return this.value?.isRequired ? "필수입력" : "선택입력";
        },
    },
    methods: {
        click() {
            this.$store.commit("employment/form/node/setActive", this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.tool-prev {
    ::v-deep .v-btn__content {
        flex-direction: row-reverse;
        gap: 8px;
    }
}
@media (min-width: 1024px) {
    .tool-prev {
        ::v-deep .v-btn__content {
            flex-direction: row;
        }
    }
}
</style>
